import { connect } from 'react-redux';
import { getIsMobile } from 'ha/modules/UI/selectors';
import ContentfulImg from '../components/ContentfulImg';

export default connect(state => ({
  isMobile: getIsMobile(state),
}))(ContentfulImg);
